import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IApproveUserReq, IApproveUserRes } from './index.type';

const useRtmUser = ({ userId }: { userId?: string }) => {
    const { loading: UserRTMLoading, makeApiCall } = useApi({
        // url: `/users/${userId}/toggleActive`,
        url: `/RTM/update-rtm-status/${userId}`,
        method: 'PATCH',
    });

    const UserRTM = async (FormData: IApproveUserReq) => {
        const { response, error } = await makeApiCall<IApproveUserReq, IApproveUserRes>(FormData);

        if (response?.status === 'success') {
            toast.success('RTM Approved successfully.');
            return response;
        }

        if (error) {
            toast.error('Something went wrong whiling approving status. Please try again later');
            return { status: 'fail' };
        }
    };

    return {
        UserRTMLoading,
        UserRTM,
    };
};

export default useRtmUser;
